// initial state
const state = {
  category: null,
  model: null,
  issue: null,
  subIssue: null,
  specificIssue: null,
  searchString: null,
  groups: null,
  resultOptions: []
}

// mutations
const mutations = {
  saveDeviceData (state, {category, model}) {
    state.category = category
    state.model = model
  },
  saveIssueData (state, {issue}) {
    state.issue = issue
  },
  saveSubIssueData (state, {subIssue}) {
    state.subIssue = subIssue
  },
  saveSpecificIssueData (state, {specificIssue}) {
    state.specificIssue = specificIssue
  },
  saveSearchString (state, {searchString}) {
    state.searchString = searchString
  },
  saveGroups (state, {groups}) {
    state.groups = groups
  },
  saveResultOptions (state, {resultOptions}) {
    state.resultOptions = resultOptions
  },

  resetData (state) {
    state.issue = null
    state.subIssue = null
    state.specificIssue = null
  },
  resetAll (state) {
    state.category = null
    state.model = null
    state.issue = null
    state.subIssue = null
    state.specificIssue = null
  }
}

export default {
  state,
  mutations
}
